module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-f723429f436e6cf119b67d433f3e943a.svg";